/**
 * Types of signed URLs for storage operations.
 * GET: For downloading/reading files
 * PUT: For uploading/writing files
 */
export var SignedUrlType;
(function (SignedUrlType) {
    SignedUrlType["GET"] = "GET";
    SignedUrlType["PUT"] = "PUT";
})(SignedUrlType || (SignedUrlType = {}));
//# sourceMappingURL=signed-url-type.enum.js.map